import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

    constructor(
        private navCtrl: NavController,
        public router: Router,
    ) { }

    ngOnInit() {}

    public goTo(path) {
        // this.navCtrl.navigateForward(path);
        this.router.navigate([path])
    }

}
